import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

import { useI18n } from '@/hooks/web/useI18n'
import { ecoCommonInfo } from '../hooks/UserBasicInfo'

dayjs.extend(utc)
dayjs.extend(timezone)

// const { t } = useI18n('ecowatch')
const { ecoLang } = ecoCommonInfo()

const ZH = 'zh'
const CNY = 'CNY'
const CNY_TEN_THOUSAND = '万元'
const CNY_BILLION = '亿元'
const CNY_TRILLION = '万亿元'

function toDoubleECO(num) {
  if (num < 10) {
    return '0' + num
  } else {
    return num
  }
}

function arrayIsNotEmpty(input) {
  let target = false
  if (input && Array.isArray(input) && input.length) {
    target = true
  }
  return target
}

// 时间戳转时间（毫秒）
function timeStamp2Time(timeStamp, type = 'date') {
  if (!timeStamp) {
    return ''
  }
  let target: any = ''
  const year = new Date(timeStamp).getFullYear()
  let month: any = new Date(timeStamp).getMonth() + 1
  month = month < 10 ? '0' + month : month
  const date = toDoubleECO(new Date(timeStamp).getDate())
  const hour = new Date(timeStamp).getHours()
  const minute = new Date(timeStamp).getMinutes()
  switch (type) {
    case 'year':
      target = year
      break
    case 'month':
      target = year + '/' + month
      break
    case 'date':
      target = month + '/' + date
      break
    case 'day':
      target = month + '/' + date
      break
    case 'hour':
      target = month + '/' + date + ' ' + toDoubleECO(hour) + ':00'
      break
    case 'minute':
      target = month + '/' + date + ' ' + toDoubleECO(hour) + ':' + toDoubleECO(minute)
      break
  }
  return target
}

function number2KeepTwoDecimals(input) {
  let target = input
  if (input instanceof Array) {
    target = input.map((val) => {
      let innerTarget = val
      if (innerTarget === '--' || innerTarget === '') {
        innerTarget = '--'
      } else {
        if (typeof innerTarget === 'number') {
          if ((innerTarget + '').indexOf('.') !== -1) {
            innerTarget = innerTarget.toFixed(2)
            innerTarget = parseFloat(innerTarget)
          }
        } else {
          if ((innerTarget + '').indexOf('.') !== -1) {
            innerTarget = Number(innerTarget).toFixed(2)
            innerTarget = parseFloat(innerTarget)
          } else if (innerTarget === '--' || innerTarget === '') {
            innerTarget = '--'
          }
          if (innerTarget + '' === 'NaN') {
            innerTarget = ''
          }
        }
      }

      return innerTarget
    })
  } else if (typeof input === 'number') {
    if ((target + '').indexOf('.') !== -1) {
      target = target.toFixed(2)
      target = parseFloat(target)
    }
  } else {
    if ((target + '').indexOf('.') !== -1) {
      target = Number(target).toFixed(2)
      target = parseFloat(target)
    } else if (!target && target === '--') {
      target = '--'
    }

    if (target + '' === 'NaN') {
      target = ''
    }
  }
  return target
}

// 时间戳转时间（毫秒）(历史数据查询专用)
function timeStamp2TimeTableForHistory(timeStamp, dateType = 'day') {
  if (!timeStamp) {
    return ''
  }
  const target: any = ''
  let date = new Date(timeStamp)
  if (
    dateType === 'hour' ||
    dateType === 'minute' ||
    dateType === '15min' ||
    dateType === '5min' ||
    dateType === '1min' ||
    dateType === 'origin'
  ) {
    return dayjs(date).format('YYYY/MM/DD HH:mm:ss')
  } else if (dateType === 'date' || dateType === 'day') {
    return dayjs(date).format('YYYY/MM/DD')
    // 因为apm的span/data返回的月时间有问题，需要做处理
  } else if (dateType === 'month') {
    date = new Date(timeStamp + 15 * 24 * 60 * 60 * 1000)
    return date.getFullYear() + '/' + toDoubleECO(date.getMonth() + 1)
    // 因为apm的span/data返回的年时间有问题，需要做处理
  } else if (dateType === 'year') {
    date = new Date(timeStamp + 180 * 24 * 60 * 60 * 1000)
    return date.getFullYear() + ''
  }
  return target
}

function getStrLength(str) {
  str += ''
  let len = 0
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i)
    // 单字节加1
    if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
      len++
    } else {
      len += 2
    }
  }
  return len
}

function getCodeLength(str, targetLen) {
  str += ''
  let len = 0
  let target = 0
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i)
    // 单字节加1
    if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
      len++
    } else {
      len += 2
    }
    if (len >= targetLen) {
      target = i
      break
    }
  }
  return target
}

const number2Comma = (input) => {
  let target = input
  if (typeof input === 'string') {
    if (input === '--') {
    } else {
      target = number2Comma(Number(input))
    }
  } else if (typeof input === 'number') {
    input = number2KeepTwoDecimals(input)
    if (input === 0) {
    } else if (input < 1000 && input > -1000) {
      target = input
    } else {
      target = (input + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    }
  }

  if (Number.isNaN(target) || target === 'NaN') {
    target = input
  }

  return target
}

// 判断显示数字展示方式
const isInteger = (number: any) => {
  // 对后台返回的null做处理，显示成-- /对后台返回的''做处理，显示--
  if (number === null || number === '') {
    return '--'
  }
  if ((Number(number) && number !== '--') || Number(number) === 0) {
    return Number(number)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  } else {
    return '--'
  }
}
const isIntegerNew = (number: any) => {
  if (number === Infinity || number === null || number === '') {
    return '--'
  }
  if ((Number(number) && number !== '--') || Number(number) === 0) {
    return Number(number)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  } else {
    return '--'
  }
}
// 数字进位-区分分类分项跟多语言
const singleCarry = (number, lang, code) => {
  const { t } = useI18n('ecowatch')
  if (number === '--') {
    if ((code + '').substring(0, 2) === '01' && lang === 'en') {
      return ['--', 'k']
    } else {
      return ['--', '']
    }
  }
  const target = Number(number)
  if (lang === 'en') {
    if (target >= 1000 * 1000 * 1000 || target <= -1 * 1000 * 1000 * 1000) {
      if ((code + '').substring(0, 2) !== '01') {
        return [
          isInteger(target / (1000 * 1000 * 1000)),
          'B',
          Number(isInteger(target / (1000 * 1000 * 1000))) * 1000 * 1000 * 1000
        ]
      }
    }
    if (target >= 1000 * 1000 || target <= -1 * 1000 * 1000) {
      if ((code + '').substring(0, 2) !== '01') {
        return [
          isInteger(target / (1000 * 1000)),
          'M',
          Number(isInteger(target / (1000 * 1000))) * 1000 * 1000
        ]
      } else {
        return [
          isInteger(target / (1000 * 1000)),
          'G',
          Number(isInteger(target / (1000 * 1000))) * 1000 * 1000
        ]
      }
    }
    if (target >= 1000 || target <= -1 * 1000) {
      if ((code + '').substring(0, 2) !== '01') {
        return [isInteger(target / 1000), 'K', Number(isInteger(target / 1000)) * 1000]
      } else {
        return [isInteger(target / 1000), 'M', Number(isInteger(target / 1000)) * 1000]
      }
    }
    if ((code + '').substring(0, 2) === '01') {
      return [isInteger(target), 'k']
    } else {
      return [isInteger(target), '']
    }
  } else {
    if (target >= 10000 * 10000 * 10000 || target <= -1 * 10000 * 10000 * 10000) {
      return [
        isInteger(target / (10000 * 10000 * 10000)),
        t('unit.wanMillion'),
        Number(isInteger(target / (10000 * 10000 * 10000))) * (10000 * 10000 * 10000)
      ]
    }
    if (target >= 10000 * 10000 || target <= -1 * 10000 * 10000) {
      return [
        isInteger(target / (10000 * 10000)),
        t('unit.hundredMillion'),
        Number(isInteger(target / (10000 * 10000))) * (10000 * 10000)
      ]
    }
    if (target >= 10000 || target <= -1 * 10000) {
      return [
        isInteger(target / 10000),
        t('unit.tenThousand'),
        Number(isInteger(target / 10000)) * 10000
      ]
    }
    return [isInteger(target), '', Number(isInteger(target))]
  }
}

function calcData(inputData, index, targetIndex = 0) {
  const newData = []
  if (arrayIsNotEmpty(inputData[index].datapoints)) {
    inputData[index].datapoints.forEach((value) => {
      if (
        value[1] &&
        value[1] * 1000 > new Date().getTime() &&
        (value[targetIndex] === 0 || value[targetIndex] === '--')
      ) {
      } else {
        newData.push(value[targetIndex])
      }
    })
  }
  return newData
}

function calcDataWithObject(inputData, targetIndex = 0) {
  const newData = []
  if (arrayIsNotEmpty(inputData.datapoints)) {
    inputData.datapoints.forEach((value) => {
      let _item = value[targetIndex]
      if (
        value[1] &&
        value[1] * 1000 > new Date().getTime() &&
        (value[targetIndex] === 0 || value[targetIndex] === '--')
      ) {
      } else {
        if (_item === '') {
          _item = '--'
        }
        newData.push(_item)
      }
    })
  }
  return newData
}

// 暂无调用（旧历史数据查询用)
function calcDataForQuery(inputData, index) {
  const newData = []
  if (Array.isArray(inputData[index].value) && inputData[index].value.length) {
    inputData[index].value.forEach((value) => {
      // if (value.ts && new Date(value.ts).getTime() > new Date().getTime()) {
      // } else {
      if (value.v === '*' || value.v === '--') {
        newData.push(value.v)
      } else {
        let target = value.v < 0.01 ? 0 : value.v
        target = parseFloat(number2KeepTwoDecimals(target))
        newData.push(target)
      }
      // }
    })
  }
  return newData
}

// 补点
function fillPoint(input) {
  // 找出最长的数据
  let _originData = []
  input.forEach((val) => {
    if (val.length > _originData.length) {
      _originData = val
    }
  })
  const _originObj = {}
  _originData.forEach((val) => {
    _originObj[val[1]] = val
  })
  // 把数组转成对象
  const _extend = []
  input.forEach((val) => {
    const _obj = {}
    val.forEach((innerVal) => {
      _obj[innerVal[1]] = innerVal
    })
    _extend.push(_obj)
  })
  // 补点
  _extend.forEach((val, index) => {
    for (const key in _originObj) {
      if (!val[key]) {
        _extend[index][key] = [0, _originObj[key][1]]
      }
    }
  })
  const target = _extend.map((val) => {
    return Object.values(val)
  })
  input.forEach((val, index) => {
    input[index] = target[index]
  })
  return target
}

// 把y轴的label转换成k和m
function label2Km(params) {
  let target = params
  if (params >= 10 * 1000) {
    target = parseInt(params / 1000 + '') + 'K'
  }
  if (params >= 10 * 1000 * 1000) {
    target = parseInt(params / 1000000 + '') + 'M'
  }
  if (params <= -10 * 1000) {
    target = parseInt(params / 1000 + '') + 'K'
  }
  if (params <= -10 * 1000 * 1000) {
    target = parseInt(params / 1000000 + '') + 'M'
  }
  return target
}

// 将节能分析曲线接口返回的时间戳数据转成X轴数据，不去除第二个开始的年、月、日
function calcxAxisOrigin(statType, inputData) {
  // let oldVal
  const targetData = inputData.map((val) => {
    const data = val[1] * 1000
    const date = new Date(data)
    if (statType === 'minute') {
      return (
        toDoubleECO(date.getMonth() + 1) +
        '/' +
        toDoubleECO(date.getDate()) +
        ' ' +
        toDoubleECO(date.getHours()) +
        ':' +
        toDoubleECO(date.getMinutes())
      )
    } else if (statType === 'hour') {
      return (
        toDoubleECO(date.getMonth() + 1) +
        '/' +
        toDoubleECO(date.getDate()) +
        ' ' +
        toDoubleECO(date.getHours()) +
        ':00'
      )
    } else if (statType === 'date' || statType === 'day') {
      return toDoubleECO(date.getMonth() + 1) + '/' + toDoubleECO(date.getDate())
    } else if (statType === 'month') {
      return date.getFullYear() + '/' + toDoubleECO(date.getMonth() + 1)
    } else if (statType === 'year') {
      return date.getFullYear() + ''
    }
  })
  return targetData
}

// 文件名用的时间
function timeStamp2TimeFileName(timeStamp, type = 'date') {
  if (!timeStamp) {
    return ''
  }
  let target: any = ''
  const year = new Date(timeStamp).getFullYear()
  let month: any = new Date(timeStamp).getMonth() + 1
  month = month < 10 ? '0' + month : month
  const date = new Date(timeStamp).getDate()
  if (type === 'year') {
    target = year
  } else if (type === 'month') {
    target = year + '-' + month
  } else if (type === 'date' || type === 'day' || type === 'week' || type === 'custom') {
    target = year + '-' + month + '-' + toDoubleECO(date)
  } else if (
    type === 'hour' ||
    type === 'minute' ||
    type === '15min' ||
    type === '5min' ||
    type === '1min' ||
    type === 'origin'
  ) {
    target = year + '-' + month + '-' + toDoubleECO(date)
  }

  return target
}

// 历史数据查询专用（调apm接口的
function calcXAxisOriginForHistory(statType, inputData) {
  // let oldVal
  const targetData = inputData.map((val) => {
    const data = new Date(val.ts).getTime()
    return timeStamp2TimeTableForHistory(data, statType)
  })
  return targetData
}

function number2KeepOneDecimals(input) {
  let target = input
  if (input instanceof Array) {
    target = input.map((val) => {
      let innerTarget = val
      if (innerTarget === '--' || innerTarget === '') {
        innerTarget = '--'
      } else {
        if (typeof innerTarget === 'number') {
          if ((innerTarget + '').indexOf('.') !== -1) {
            // if (target < 0.01) {
            //   target = target.toFixed(4)
            // } else {
            innerTarget = innerTarget.toFixed(1)
            innerTarget = parseFloat(innerTarget)
            // }
          }
        } else {
          if ((innerTarget + '').indexOf('.') !== -1) {
            innerTarget = Number(innerTarget).toFixed(1)
            // }
            innerTarget = parseFloat(innerTarget)
          } else if (innerTarget === '--' || innerTarget === '') {
            innerTarget = '--'
          }
          if (innerTarget + '' === 'NaN') {
            innerTarget = ''
          }
        }
      }

      return innerTarget
    })
  } else if (typeof input === 'number') {
    if ((target + '').indexOf('.') !== -1) {
      // if (target < 0.01) {
      //   target = target.toFixed(4)
      // } else {
      target = target.toFixed(1)
      target = parseFloat(target)
      // }
    }
  } else {
    if ((target + '').indexOf('.') !== -1) {
      // if (target < 0.01) {
      //   target = target.toFixed(4)
      // } else {
      target = Number(target).toFixed(1)
      target = parseFloat(target)
      // }
    } else if (!target && target === '--') {
      target = '--'
    }

    if (target + '' === 'NaN') {
      target = ''
    }
  }
  return target
}

// 删除未来的数据
function filterForDeleteFuture(input, statType = 'minute') {
  let target = []
  if (arrayIsNotEmpty(input)) {
    input.forEach((val) => {
      const arr = JSON.parse(JSON.stringify(val))
      if (arrayIsNotEmpty(arr) && arr[1]) {
        let _currentDate
        let currentTimeStamp
        const _time = arr[1] * 1000
        const _year = new Date(_time).getFullYear()
        const _month = toDoubleECO(new Date(_time).getMonth() + 1)
        const _date = toDoubleECO(new Date(_time).getDate())
        const _hour = toDoubleECO(new Date(_time).getHours())
        const _minute = toDoubleECO(new Date(_time).getMinutes())
        if (statType === 'minute') {
          _currentDate = _year + '/' + _month + '/' + _date
          currentTimeStamp = new Date(_currentDate)
          currentTimeStamp.setHours(_hour)
          currentTimeStamp.setMinutes(_minute)
        } else if (statType === 'hour') {
          _currentDate = _year + '/' + _month + '/' + _date
          currentTimeStamp = new Date(_currentDate)
          currentTimeStamp.setHours(_hour)
        } else if (statType === 'date') {
          _currentDate = _year + '/' + _month + '/' + _date
          currentTimeStamp = new Date(_currentDate).getTime()
        } else if (statType === 'month') {
          _currentDate = _year + '/' + _month
          currentTimeStamp = new Date(_currentDate).getTime()
        } else if (statType === 'year') {
          _currentDate = _year + ''
          currentTimeStamp = new Date(_currentDate).getTime()
        }

        if (currentTimeStamp <= new Date().getTime()) {
          arr[0] = number2KeepTwoDecimals(arr[0])
          target.push(arr)
        }
      }
    })
  }
  if (!arrayIsNotEmpty(target)) {
    target = input
  }
  return target
}

function calcReqExportData(input, statType) {
  const reqExportData = input
  const target = reqExportData
  if (arrayIsNotEmpty(target.requestData)) {
    target.requestData.forEach((val, index) => {
      if (val.datapoints) {
        target.requestData[index].datapoints = filterForDeleteFuture(val.datapoints, statType)
      }
    })
  }
  return target
}

function handleDataForExport({ targetData, originData, isClassify }) {
  let target = []
  if (arrayIsNotEmpty(originData)) {
    // 把源数据转成对象
    const _originDataObj = {}
    originData.forEach(([value, timestamp]) => {
      if (value && timestamp) {
        _originDataObj[timestamp] = value
      }
    })
    // 把目标数据转成对象
    const _targetDataObj = {}
    targetData.forEach(([value, timestamp]) => {
      if (value && timestamp) {
        _targetDataObj[timestamp] = value
      }
    })

    if (targetData.length !== originData.length) {
      // 是分类分项
      if (isClassify) {
        originData.forEach(([value, timestamp]) => {
          if (value !== undefined && timestamp !== undefined) {
            const _value = _targetDataObj[timestamp]
            let _arr
            if (_value !== undefined) {
              _arr = [_value, timestamp]
            } else {
              _arr = [0, timestamp]
              // _arr = ['--', timestamp]
            }
            target.push(_arr)
          }
        })
        // 不是分类分项
      } else {
        originData.forEach(([value, timestamp]) => {
          if (value !== undefined && timestamp !== undefined) {
            const _value = _targetDataObj[timestamp]
            let _arr
            // 对标值存在
            if (_value !== undefined) {
              _arr = [_value, timestamp]
              // 对标值不存在
            } else {
              _arr = [0, timestamp]
            }
            target.push(_arr)
          }
        })
      }
    } else {
      target = targetData
    }
  }
  return target
}

function handleDataForExportHistory({ targetData, originData, isClassify }) {
  let target = []
  if (arrayIsNotEmpty(originData)) {
    // 把源数据转成对象
    const _originDataObj = {}
    originData.forEach(({ ts, v }) => {
      if (v && ts) {
        _originDataObj[ts] = v
      }
    })
    // 把目标数据转成对象
    const _targetDataObj = {}
    targetData.forEach(({ ts, v }) => {
      if (v && ts) {
        _targetDataObj[ts] = v
      }
    })

    if (targetData.length !== originData.length) {
      // 是分类分项
      if (isClassify) {
        originData.forEach(({ ts, v }) => {
          if (v !== undefined && ts !== undefined) {
            const _value = _targetDataObj[ts]
            let _arr
            if (_value !== undefined) {
              _arr = [_value, ts]
            } else {
              _arr = [0, ts]
              // _arr = ['--', timestamp]
            }
            target.push(_arr)
          }
        })
        // 不是分类分项
      } else {
        originData.forEach(({ ts, v }) => {
          if (v !== undefined && ts !== undefined) {
            const _value = _targetDataObj[ts]
            let _arr
            // 对标值存在
            if (_value !== undefined) {
              _arr = [_value, ts]
              // 对标值不存在
            } else {
              _arr = [0, ts]
            }
            target.push(_arr)
          }
        })
      }
    } else {
      target = targetData
    }
  }
  return target
}

function transform2Abs(input) {
  let target = input
  if (Array.isArray(input) && input.length) {
    input.forEach((val) => {
      target.push(transform2Abs(val))
    })
  } else {
    if (typeof input === 'number') {
      if (Number.isNaN(input)) {
        target = ''
      } else {
        target = Math.abs(target)
      }
    }
  }
  return target
}

// 递归函数
function nodefuns(newVal, selectValue) {
  let flag = false
  let cidList = []
  newVal.forEach((item) => {
    if (item.value === selectValue) {
      cidList = item
      flag = true
    } else {
      if (item.children) {
        const list = nodefuns(item.children, selectValue)
        if (list) {
          cidList = list
          flag = true
        }
      }
    }
  })
  if (flag) {
    return cidList
  }
}

function getSelectArea(data, selectValue) {
  const Department = data
  let cidList = []
  Department.forEach((item) => {
    if (item.value === selectValue) {
      cidList = item
      return false
    } else {
      if (item.children) {
        const list = nodefuns(item.children, selectValue)
        if (list) {
          cidList = list
        }
      }
    }
  })
  return cidList
}

function timeStamp2TimeMultiTimeCompare(timeStamp, type = 'date') {
  if (!timeStamp) {
    return ''
  }
  timeStamp *= 1000
  let target: any = ''
  const year = new Date(timeStamp).getFullYear()
  let month: any = new Date(timeStamp).getMonth() + 1
  month = month < 10 ? '0' + month : month
  let date: any = new Date(timeStamp).getDate()
  date = date < 10 ? '0' + date : date
  let hour: any = new Date(timeStamp).getHours()
  hour = hour < 10 ? '0' + hour : hour
  let minute: any = new Date(timeStamp).getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  switch (type) {
    case 'year':
      target = year
      break
    case 'month':
      target = year + '/' + month
      break
    case 'date':
      target = year + '/' + month + '/' + date
      break
    case 'hour':
      target = year + '/' + month + '/' + date + ' ' + hour + ':' + minute
      break
    case 'minute':
      target = year + '/' + month + '/' + date + ' ' + hour + ':' + minute
      break
  }
  return target
}

// 表格没有数据统一返回--
const handleTableNoData = (params) => {
  if (params === 0) return 0
  if (!params) return '--'
  if (Array.prototype.isPrototypeOf(params) && params.length === 0) return '--'
  if (Object.prototype.isPrototypeOf(params) && Object.keys(params).length === 0) return '--'
  return params
}

// js判断字节数 isDefaultNum需量列全是数字，默认只加1
const strCode = (num, isDefaultNum = false) => {
  //获取字符串的字节数
  let count = 0 //初始化字节数递加变量并获取字符串参数的字符个数
  if (num) {
    //如果存在字符串，则执行
    const str = num + ''
    const len = str.length
    for (let i = 0; i < len; i++) {
      if (isDefaultNum) {
        count += 1 //则累加2个
      } else {
        //遍历字符串，枚举每个字符 48-57是数字 65-90大写字母 97-122是小写字母 58(:) 95(_) 47(/)
        if (
          (str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122) ||
          str.charCodeAt(i) === 58 ||
          str.charCodeAt(i) === 95
        ) {
          count += 1 //则累加2个
        } else if (str.charCodeAt(i) >= 39 && str.charCodeAt(i) <= 63) {
          count += 1.3
        } else {
          //字符编码大于255，说明是双字节字符(即是中文)
          count += 2 //否则递加一次
        }
      }
    }
    return count //返回字节数
  } else {
    return 0 //如果参数为空，则返回0个
  }
}

// 根据最长值计算宽度
const flexColumnWidth = (str, tableData, lang = ZH, isDefaultNum = false) => {
  // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
  // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
  str = str + ''
  let columnContent = ''
  if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
    return
  }
  if (!str || !str.length || str.length === 0 || str === undefined) {
    return
  }
  // 获取该列中最长的数据(内容)
  let index = 0
  for (let i = 0; i < tableData.length; i++) {
    if (tableData[i][str]) {
      const now_temp = tableData[i][str] + ''
      const max_temp = tableData[index][str] + ''
      if (now_temp.length > max_temp.length) {
        index = i
      }
    }
  }
  columnContent = tableData[index][str]
  // 以下分配的单位长度可根据实际需求进行调整
  if (typeof columnContent === 'undefined') {
    columnContent = '--'
  }
  let flexWidth = 0
  const codeLength = strCode(columnContent, isDefaultNum)
  flexWidth = codeLength * 8.5
  // 设置最小宽度 该宽度可能会因页面不同需要测试 默认90
  const minWidth = lang === 'en' ? 170 : 100
  if (flexWidth < minWidth) {
    // 设置最小宽度
    flexWidth = minWidth
  }
  // 24为表格padding之和
  return flexWidth + 30
}

//字符宽度计算
const flexStrWidth = (str, fontSize) => {
  str = str + ''
  // 以下分配的单位长度可根据实际需求进行调整
  let flexWidth = 0
  const codeLength = strCode(str)
  flexWidth = codeLength * fontSize
  return flexWidth
}

// 下载表格数据保留两位但不千分位
const isDownloadInteger = (number: any) => {
  // 对后台返回的null做处理，显示成--
  if (number === null || number === '') {
    return '--'
  }
  if ((Number(number) && number !== '--') || Number(number) === 0) {
    return Number(number).toFixed(2)
  } else {
    return '--'
  }
}

// 判断显示数字为整数-人数
const isDownloadNumber = (number: any) => {
  if (number === '--' || number === null || number === '') return '--'
  return Number(Number(number).toFixed(0))
}

// 判断显示数字为整数
const isNumber = (number: any) => {
  if (number === '--' || number === null || number === '') return '--'
  if ((Number(number) && number !== '--') || Number(number) === 0) {
    return Number(Number(number).toFixed(0)).toLocaleString()
  } else {
    return '--'
  }
}

// 时间格式转换-增加对时区的处理 targetTimezone = 'Asia/Hong_Kong'
const timestampToTime = (timestamp, flag = 'Y/M/D h:m:s', targetTimezone?) => {
  if (timestamp === '--' || timestamp === '' || !targetTimezone) return '--'

  let target = ''
  let time = String(timestamp)
  // 时区偏移量是以小时为单位提供的，所以需要将其转换为毫秒进行计算
  time = time.length <= 10 ? timestamp * 1000 : timestamp
  const date = new Date(time)
  // const formattedDate = date.toLocaleString('zh-CN', { timeZone: targetTimezone })

  const timezoneBefore = dayjs.tz(new Date(), targetTimezone)
  const offset = timezoneBefore.utcOffset() / 60
  let formattedDate = dealTimeByTimezone({ time: date, timezone: offset })
  formattedDate = Math.floor(formattedDate / 1000) * 1000

  const adjustedDate = new Date(formattedDate)
  const Y = adjustedDate.getFullYear()
  const M =
    adjustedDate.getMonth() + 1 < 10
      ? '0' + (adjustedDate.getMonth() + 1)
      : adjustedDate.getMonth() + 1
  const D = adjustedDate.getDate() < 10 ? '0' + adjustedDate.getDate() : adjustedDate.getDate()
  const h = adjustedDate.getHours() < 10 ? '0' + adjustedDate.getHours() : adjustedDate.getHours()
  const m =
    adjustedDate.getMinutes() < 10 ? '0' + adjustedDate.getMinutes() : adjustedDate.getMinutes()
  const s =
    adjustedDate.getSeconds() < 10 ? '0' + adjustedDate.getSeconds() : adjustedDate.getSeconds()

  switch (flag) {
    case 'YMDhms':
      target = `${Y}${M}${D}${h}${m}${s}`
      break
    case 'Y/M/D':
      target = `${Y}/${M}/${D}`
      break
    case 'Y-M-D':
      target = `${Y}-${M}-${D}`
      break
    case 'YMDhm':
      target = `${Y}/${M}/${D} ${h}:${m}`
      break
    case 'MDhm':
      target = `${M}/${D} ${h}:${m}`
      break
    case 'hm':
      target = `${h}:${m}`
      break
    case 'hms':
      target = `${h}:${m}:${s}`
      break
    case 'M/D':
      target = `${M}/${D}`
      break
    case 'Y-M-D h:m:s':
      target = `${Y}-${M}-${D} ${h}:${m}:${s}`
      break
    case 'Y':
      target = `${Y}`
      break
    case 'M':
      target = `${M}`
      break
    case 'D':
      target = `${M}/${D}`
      break
    case 'h':
      target = `${M}/${D} ${h}:${m}`
      break
    case 'Y/M':
      target = `${Y}/${M}`
      break
    default:
      target = `${Y}/${M}/${D} ${h}:${m}:${s}`
      break
  }

  return target
}

// 根据区域的value 获取同级信息
const getCurRegionInfo = (arr, val) => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].value == val) {
      return arr[i]
    } else {
      if (arr[i].children) {
        const _item = getCurRegionInfo(arr[i].children, val)
        if (_item) return _item
      }
    }
  }
}

// 控制只能输入正整数及小数
const checkNumber = (newVal) => {
  newVal = newVal
    .replace(/[^\d.]/g, '') // 清除除“数字”和“.”以外的字符
    .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
    .replace(/^\./g, '') //保证第一个为数字而不是.
    .replace('.', '$#$')
    .replace(/\./g, '')
    .replace('$#$', '.')
    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
  if (newVal.indexOf('.') < 0 && newVal != '') {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    newVal = parseFloat(newVal)
  }
  return newVal
}

/**
 * 对数组对象的指定属性进行排序
 * @param {Array} arr 数组对象
 * @param {Array} rules 排序规则，每个元素都是形如 ['key', 'asc'] 或者 ['key', 'desc'] 的数组
 */
const commonSortBy = (arr, rules) => {
  return arr.sort((a, b) => {
    for (let i = 0; i < rules.length; i++) {
      const [key, direction] = rules[i]
      const order = direction === 'desc' ? -1 : 1
      if (a[key] < b[key]) {
        return -1 * order
      }
      if (a[key] > b[key]) {
        return 1 * order
      }
    }
    return 0
  })
}

// 判空处理 包括null undefined {} [] ''
const isEmpty = (params) => {
  if (!params && params != 0) return true
  if (Array.prototype.isPrototypeOf(params) && params.length === 0) return true
  if (Object.prototype.isPrototypeOf(params) && Object.keys(params).length === 0) return true
  return false
}

// 判空处理 包括null undefined {} [] ''
const isEleEmpty = (params) => {
  if (!params && params != 0) return true
  if (Array.prototype.isPrototypeOf(params) && params.length === 0) return true
  if (Object.prototype.isPrototypeOf(params) && Object.keys(params).length === 0) return true
  return false
}

// 获取Excel的对应的列 比如getColumnAlphabet(1) = 'A'
const getColumnAlphabet = (index) => {
  let dividend = index + 1
  let alphabet = ''

  while (dividend > 0) {
    const modulo = (dividend - 1) % 26
    alphabet = String.fromCharCode(65 + modulo) + alphabet
    dividend = Math.floor((dividend - modulo) / 26)
  }

  return alphabet
}

// 判断显示数字展示方式-仅千分位与无数据--
const showDieThousand = (number: any) => {
  if (number === null || number === '') return '--'
  if ((Number(number) && number !== '--') || Number(number) === 0) {
    return number
  } else {
    return '--'
  }
}

// 所有粒度的时间戳的生成-除了分钟
const allIntervalTimeStamps = ({ timezoneAfter, interval, startDate, endDate, offset }) => {
  const timestamps = []

  const currentDate = new Date(startDate)
  const finalDate = new Date(endDate)

  switch (interval) {
    case 'year':
      // 1994-2023-可能传字符串
      let currentYear = currentDate.getFullYear()
      while (currentYear <= finalDate.getFullYear()) {
        timestamps.push(
          dealTimeByTimezoneConfig({
            time: new Date(currentYear, 0, 1).getTime(),
            timezone: timezoneAfter,
            dayOfStartAfter: offset
          })
        )
        currentYear++
      }
      break
    case 'month':
      while (currentDate <= finalDate) {
        const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1, 0, 0, 0)
        timestamps.push(
          dealTimeByTimezoneConfig({
            time: startOfMonth.getTime(),
            timezone: timezoneAfter,
            dayOfStartAfter: offset
          })
        )
        currentDate.setMonth(currentDate.getMonth() + 1)
      }
      break
    case 'day':
      while (currentDate <= finalDate) {
        const timestampDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          0,
          0,
          0
        )
        timestamps.push(
          dealTimeByTimezoneConfig({
            time: timestampDate.getTime(),
            timezone: timezoneAfter,
            dayOfStartAfter: offset
          })
        )
        currentDate.setDate(currentDate.getDate() + 1)
      }
      break
    case 'hour':
      const endTarget = new Date(finalDate.getTime() + 24 * 60 * 60 * 1000 - 1)
      while (currentDate <= endTarget) {
        timestamps.push(
          dealTimeByTimezoneConfig({
            time: currentDate.getTime(),
            timezone: timezoneAfter
          })
        )
        currentDate.setHours(currentDate.getHours() + 1)
      }
      break
    default:
      break
  }

  return timestamps
}

// 根据时间戳获取对应粒度的结束时间
const getIntervalEndTime = ({ timestamp, interval, timezoneAfter, timezone, offset }) => {
  // setUTCMonth-不受时区与夏令时影响 setMonth-受影响
  let target
  const date = new Date(timestamp)
  // const formattedDate = date.toLocaleString('zh-CN', { timeZone: timezone })
  const timezoneBefore = dayjs.tz(new Date(), timezone)
  const offset2 = timezoneBefore.utcOffset() / 60
  let formattedDate = dealTimeByTimezone({ time: date, timezone: offset2 })
  formattedDate = Math.floor(formattedDate / 1000) * 1000
  const adjustedDate = new Date(formattedDate)

  switch (interval) {
    case 'year':
      adjustedDate.setFullYear(adjustedDate.getFullYear() + 1)
      adjustedDate.setMonth(0)
      adjustedDate.setDate(1)
      adjustedDate.setHours(0, 0, 0, 0)

      target = adjustedDate.getTime()
      break
    case 'month':
      adjustedDate.setMonth(adjustedDate.getMonth() + 1)
      adjustedDate.setDate(1)
      adjustedDate.setHours(0, 0, 0, 0)

      target = adjustedDate.getTime()
      break
    case 'day':
      adjustedDate.setDate(adjustedDate.getDate() + 1)
      adjustedDate.setHours(0, 0, 0, 0)

      target = adjustedDate.getTime()
      break
    case 'hour':
      adjustedDate.setHours(adjustedDate.getHours() + 1)
      adjustedDate.setMinutes(0)
      adjustedDate.setSeconds(0)
      adjustedDate.setMilliseconds(0)
      adjustedDate.setDate(adjustedDate.getDate())
      adjustedDate.setHours(0, 0, 0, 0)

      target = adjustedDate.getTime()
      break
    default:
      break
  }

  return dealTimeByTimezoneConfig({
    time: target,
    timezone: timezoneAfter,
    dayOfStartAfter: offset
  })
}

// 计算倒数日期 previousMonth=false，计算当前月的倒数日期。previousMonth=true，计算上个月的倒数日期
const calculateDate = (dayOfMonth, previousMonth = false) => {
  const currentDate = new Date()
  let currentYear = currentDate.getFullYear()
  let currentMonth = currentDate.getMonth() + 1

  if (previousMonth) {
    currentMonth -= 1
    if (currentMonth === 0) {
      currentMonth = 12
      currentYear -= 1
    }
  }

  const totalDaysInMonth = new Date(currentYear, currentMonth, 0).getDate()
  const targetDate = totalDaysInMonth - dayOfMonth + 1

  return targetDate
}

// 要判断当前日期是否大于输入日期-inputDate格式为'月/日'
const isMoreThanCurrentDate = (inputDateStr) => {
  // 将输入日期转换为 Date 对象
  const inputDateParts = inputDateStr.split('/')
  const inputMonth = parseInt(inputDateParts[0], 10)
  const inputDay = parseInt(inputDateParts[1], 10)
  const inputDate = new Date(new Date().getFullYear(), inputMonth - 1, inputDay) // 将年份设为当前年份

  // 获取当前日期
  const currentDate = new Date()
  currentDate.setHours(0, 0, 0, 0)

  // 比较当前日期和输入日期
  if (currentDate.getTime() <= inputDate.getTime()) {
    return true
  } else {
    return false
  }
}

const transformUnit = ({ value, rate }) => {
  let target = value
  if (value !== 0) {
    target = number2KeepTwoDecimals(value / rate)
  }
  return target
}

const getArrayCurrencyFormat = ({ data, currency }) => {
  let targetData = data
  let unit = currency
  let rate = 1
  if (data?.length) {
    const maxValue = Math.max(...data)
    const result = getCurrencyFormatNew({ currency, value: maxValue, isMin: true })
    rate = result.rate
    unit = result.unit
    targetData = data.map((value) => {
      return transformUnit({ value, rate })
    })
  }
  return {
    data: targetData,
    unit: unit,
    rate
  }
}

const oldCurrency = {
  $: 'USD',
  NT$: 'NTD',
  元: 'CNY'
}

// 产值币种进位(新)-可匹配存在目标产值时,isTarget-代表是否为需要进位的目标值,isMin代表是否按照默认币种最小进位值进位
const getCurrencyFormatNew = (params: any) => {
  const { currency, value, maxVal, isTarget = false, isMin = true } = params
  let curCurrency = currency
  if (oldCurrency.hasOwnProperty(currency)) {
    curCurrency = oldCurrency[currency]
  }

  let currencyUnit = 'K ' + curCurrency
  let roundingSetting = [
    { value: 1000 * 1000 * 1000, unit: `B ${curCurrency}` },
    { value: 1000 * 1000, unit: `M ${curCurrency}` },
    { value: 1000, unit: `K ${curCurrency}` }
  ]
  if (curCurrency === CNY && ecoLang.value === ZH) {
    currencyUnit = CNY_TEN_THOUSAND
    roundingSetting = [
      { value: 10000 * 10000 * 10000, unit: CNY_TRILLION },
      { value: 10000 * 10000, unit: CNY_BILLION },
      { value: 10000, unit: CNY_TEN_THOUSAND }
    ]
  }

  let result: any = {
    value: '--',
    unit: currencyUnit
  }

  if (isInteger(value) !== '--') {
    const numberValue = parseFloat(value)
    let maxCalculate = 1000
    if (isMin) {
      if (curCurrency === CNY && ecoLang.value === ZH) {
        maxCalculate = 10000
      }
    } else {
      maxCalculate = parseFloat(maxVal)
    }

    // 检查是否小于最小阈值，进行特殊处理
    if (maxCalculate < roundingSetting[roundingSetting.length - 1].value) {
      if (isTarget) {
        result = {
          value: numberValue,
          unit: roundingSetting[roundingSetting.length - 1].unit,
          rate: roundingSetting[roundingSetting.length - 1].value
        }
      } else {
        result = {
          value: numberValue / roundingSetting[roundingSetting.length - 1].value,
          unit: roundingSetting[roundingSetting.length - 1].unit,
          rate: roundingSetting[roundingSetting.length - 1].value
        }
      }
    } else {
      for (let i = 0; i < roundingSetting.length; i++) {
        const { value: threshold, unit: unitValue } = roundingSetting[i]
        if (maxCalculate >= threshold) {
          if (isTarget) {
            result = {
              value: numberValue,
              unit: unitValue,
              rate: threshold
            }
          } else {
            result = {
              value: numberValue / threshold,
              unit: unitValue,
              rate: threshold
            }
          }

          break
        }
      }
    }
  }
  return result
}

// 乘数根据最大值的单位进行获取,currency接口获取的单位，unit-币种转换后的单位-目标单耗在CNY时不论何种语言都是按照万元配置
const getMultiplier = (currency, unit) => {
  let curCurrency = currency
  if (oldCurrency.hasOwnProperty(currency)) {
    curCurrency = oldCurrency[currency]
  }
  let roundingSetting = [
    { value: 1000 * 1000 * 1000, unit: `B ${curCurrency}` },
    { value: 1000 * 1000, unit: `M ${curCurrency}` },
    { value: 1000, unit: `K ${curCurrency}` }
  ]
  if (curCurrency === CNY) {
    if (ecoLang.value === ZH) {
      roundingSetting = [
        { value: 10000 * 10000, unit: CNY_TRILLION },
        { value: 10000, unit: CNY_BILLION },
        { value: 1, unit: CNY_TEN_THOUSAND }
      ]
    } else {
      roundingSetting = [
        { value: 1000 * 100, unit: `B ${curCurrency}` },
        { value: 100, unit: `M ${curCurrency}` },
        { value: 0.1, unit: `K ${curCurrency}` }
      ]
    }
  }

  const target = roundingSetting?.find((item) => item.unit === unit)
  return target.value
}

// 限制输入框只能输入数字，小数
export const checkText = (input) => {
  // 非数字和小数点替换为空
  input = input.replace(/[^\d.]/g, '')
  // 以小数点开始替换为空
  input = input.replace(/^\./g, '')
  // 连续两个小数点只保留一个小数点（这句和最后一条功能重复了，注释掉）
  // input = input.replace(/\.{2,}/g, '.')
  input = input.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
  // 以两个0开始替换为一个0
  input = input.replace(/^00/g, '0')
  // 只保留一个小数点
  input = input.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
  return input
}

// 求最小值-echarts坐标轴
const getDataMin = (arr) => {
  let y_Min = Math.min(...arr)

  if (y_Min >= 0) {
    y_Min = 0
  } else {
    // 向下取整
    y_Min = Math.floor(y_Min)
  }

  return y_Min
}

// 求最小值-echarts坐标轴
const getDataMax = (arr) => {
  let y_Max = Math.max(...arr)

  if (y_Max <= 0) {
    y_Max = 1
  } else {
    y_Max = Math.ceil(y_Max)
  }

  return y_Max
}

//求平均值-echarts坐标轴
const getDataAverage = (arr) => {
  let allAverage = 0
  let allTotal = 0

  if (arr?.length) {
    arr.forEach((item) => {
      allTotal += Number(item)
    })
    allAverage = allTotal / arr.length
    // 该部分是防止数据都为0 echarts的y轴渲染异常
    if (allAverage === 0) allAverage = 0.5
  }

  return allAverage
}

// echarts对应值根据自定义y轴变化
const getCustomShowYData = (arr, tickArr) => {
  const showData = []

  for (let i = 0; i < arr?.length; i++) {
    let current
    if (arr[i]?.value) {
      current = arr[i].value[1]
    } else if (Array.isArray(arr[i])) {
      current = arr[i][1]
    } else {
      current = arr[i]
    }

    // 寻找在数据间隔里面小于benQiDanHao的最大值
    const min_v = Math.max(...tickArr?.filter((v) => v <= current))
    // 寻找min_v的下标
    const index = tickArr?.findIndex((v) => v === min_v)
    // 寻找在数据间隔里面大于benQiDanHao的最小值
    const max_v = Math.min(...tickArr?.filter((v) => v > current))
    // 计算该值在y轴上对应的位置
    let y_value = current
    if (!Number.isNaN(Number(y_value))) {
      y_value = ((current - min_v) / (max_v - min_v)) * 10 + index * 10
    }

    if (arr[i]?.value) {
      showData[i] = {
        ...arr[i],
        value: [arr[i].value[0], y_value]
      }
    } else if (Array.isArray(arr[i])) {
      showData[i] = [arr[i][0], y_value]
    } else {
      showData[i] = y_value
    }
  }

  return showData
}

// 查询页面-本地时间转换为指定时区时间
export const transformUtcByTimezone = ({ time, timezone, dayOfStartAfter = 0 }) => {
  const date = new Date(time)

  // 调整时区偏移量
  const currentTimezone = new Date().getTimezoneOffset()
  const adjustedDate = new Date(
    date.getTime() - timezone * 60 * 60 * 1000 - currentTimezone * 60 * 1000 + dayOfStartAfter
  )
  // 将调整后的日期转换为ISO 8601格式的字符串
  // const formattedDate = adjustedDate.toISOString()

  return adjustedDate
}

// 时间戳转换为指定时区时间
export const dealTimeByTimezone = ({ time, timezone, dayOfStartAfter = 0 }) => {
  const date = new Date(time)

  // 调整时区偏移量
  const currentTimezone = new Date().getTimezoneOffset()
  const adjustedDate = new Date(
    date.getTime() + timezone * 60 * 60 * 1000 + currentTimezone * 60 * 1000 - dayOfStartAfter
  ).getTime()

  return adjustedDate
}

// 配置页面-把按时区转后的时间转成时间戳
export const dealTimeByTimezoneConfig = ({ time, timezone, dayOfStartAfter = 0 }) => {
  const input = transformUtcByTimezone({ time, timezone, dayOfStartAfter })

  return new Date(input).getTime()
}

// datapoints按照时区转换
export const dealDatapointsByTimezone = ({ datapoints, timezone, isSecond = true }) => {
  if (datapoints && datapoints?.length) {
    datapoints.forEach((item) => {
      let time = item[1]
      if (isSecond) {
        time = time * 1000
      }

      const input = new Date(dealTimeByTimezone({ time: time, timezone })).getTime()
      if (isSecond) {
        item[1] = input / 1000
      } else {
        item[1] = input
      }
    })
  }

  return datapoints
}

// 判断本地时区
const getLocalTimezone = () => {
  // 时区不可能为空，只要有资产组就有时区
  const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const timezoneBefore = dayjs.tz(new Date(), localTimezone)

  const offset = timezoneBefore.utcOffset() / 60

  return {
    value: offset,
    label: localTimezone
  }
}

// 根据时区转换
const timezoneTarget = (time, timezoneAfter, dayOfStartAfter = 0) => {
  if (time) {
    return transformUtcByTimezone({ time, timezone: timezoneAfter, dayOfStartAfter }).toISOString()
  }

  return time
}

// 要获取特定时区的 GMT 偏移量
const getEcoTimezoneOffset = () => {
  const date = new Date() // 创建一个新的 Date 对象，默认为当前日期和时间
  const timezoneOffset = date.getTimezoneOffset() // 获取本地时区相对于 GMT 的偏移量（单位为分钟）

  const hours = Math.abs(Math.floor(timezoneOffset / 60)) // 将分钟转换为小时，并取绝对值
  const minutes = Math.abs(timezoneOffset % 60) // 获取分钟部分，并取绝对值

  const sign = timezoneOffset > 0 ? '-' : '+' // 判断偏移量正负号

  const gmtOffset = `GMT${sign}${hours.toString().padStart(2, '0')}${minutes
    .toString()
    .padStart(2, '0')}` // 构建 GMT 偏移量字符串

  // 输出结果为：GMT+07:00
  return gmtOffset
}

// 获取指定年份的第一天和最后一天
const getCustomYearTime = ({ time, timezoneAfter, dayOfStartAfter }) => {
  const beginTime = new Date(time + '')
  const endTime = new Date(time + '')

  // 获取本年第一天
  beginTime.setDate(1)
  beginTime.setMonth(0)
  beginTime.setHours(0, 0, 0, 0)
  // 获取本年最后一天
  endTime.setFullYear(endTime.getFullYear() + 1)
  endTime.setDate(1)
  endTime.setMonth(0)
  endTime.setHours(0, 0, 0, 0)

  let start = new Date(beginTime).getTime()
  start = dealTimeByTimezoneConfig({ time: start, timezone: timezoneAfter })

  let end = new Date(endTime).getTime()
  end = dealTimeByTimezoneConfig({ time: end, timezone: timezoneAfter })

  return {
    beginTime: new Date(start + dayOfStartAfter).toISOString(),
    endTime: new Date(end + dayOfStartAfter).toISOString()
  }
}

// 根据区间返回导出文件日期名称
const getFileDateName = (time, interval, timezone) => {
  let target = ''

  switch (interval) {
    case 'year':
      target = timestampToTime(time, 'Y', timezone)
      break
    case 'month':
      target = timestampToTime(time, 'Y/M', timezone)
      break
    case 'day':
    case 'date':
    case 'week':
    case 'custom':
      target = timestampToTime(time, 'Y/M/D', timezone)
      break
    case 'hour':
    case 'minute':
      target = timestampToTime(time, 'M/D', timezone)
      break
    default:
      break
  }

  return target
}

// 根据区间返回echarts图x轴数据
const getEchartsXData = (data, interval, timezone) => {
  const target = []

  data?.map((row) => {
    let date = ''
    switch (interval) {
      case 'year':
        date = timestampToTime(row[1], 'Y', timezone)
        break
      case 'month':
        date = timestampToTime(row[1], 'Y/M', timezone)
        break
      case 'day':
      case 'date':
        date = timestampToTime(row[1], 'M/D', timezone)
        break
      case 'hour':
        date = timestampToTime(row[1], 'h', timezone)
        break
      case 'minute':
        date = timestampToTime(row[1], 'MDhm', timezone)
        break
      default:
        break
    }
    target.push(date)
  })

  return target
}

// 反向时间戳计算-周末背景阴影
const getBackgroundShadowDate = (timestamp, timezoneAfter) => {
  const date = new Date() // 创建一个新的 Date 对象，默认为当前日期和时间
  const timezoneOffset = date.getTimezoneOffset()
  const time = timestamp + timezoneAfter * 60 * 60 * 1000 + timezoneOffset * 60 * 1000

  return time
}

// 为区域增加key
const addKeyForLocationOptions = (input) => {
  if (input && input.length) {
    const _len = input.length
    for (let i = _len - 1; i >= 0; i--) {
      if (!input[i].key) {
        input[i].key = input[i].groupId + '_' + input[i].value
      }
      if (input[i].children && input[i].children.length) {
        addKeyForLocationOptions(input[i].children)
      }
    }
  }
}

// 同比数据对比补点,times完整时间戳 arr需要补点的数组 showVal补点的数据
const getYOYAllData = ({ times, arr, timezone, showVal }) => {
  // 获取所有数据中的时间戳集合
  const targetData = arr.map(({ target, datapoints }) => {
    const newDataPoints = []
    times.forEach(([index, timestamp]) => {
      const foundDataPoint = datapoints?.find(
        ([value, ts]) =>
          timestampToTime(ts, 'M/D', timezone) === timestampToTime(timestamp, 'M/D', timezone)
      )
      if (foundDataPoint) {
        newDataPoints.push(foundDataPoint)
      } else {
        newDataPoints.push([showVal, timestamp])
      }
    })

    return { target, datapoints: newDataPoints }
  })

  return targetData
}

export const exportFile = ({ response, fileName }) => {
  if (response && fileName) {
    const blob = response.data
    const reader = new FileReader()
    reader.readAsDataURL(blob as any)
    reader.onload = (e) => {
      const a = document.createElement('a')
      a.download = `${fileName}.xlsx`
      a.href = e.target!.result as string
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
}

export {
  isIntegerNew,
  toDoubleECO,
  arrayIsNotEmpty,
  calcData,
  calcDataWithObject,
  timeStamp2Time,
  number2KeepTwoDecimals,
  getStrLength,
  getCodeLength,
  number2Comma,
  singleCarry,
  fillPoint,
  label2Km,
  calcxAxisOrigin,
  timeStamp2TimeFileName,
  calcDataForQuery,
  number2KeepOneDecimals,
  calcReqExportData,
  handleDataForExport,
  handleDataForExportHistory,
  transform2Abs,
  getSelectArea,
  calcXAxisOriginForHistory,
  timeStamp2TimeTableForHistory,
  timeStamp2TimeMultiTimeCompare,
  handleTableNoData,
  isInteger,
  flexColumnWidth,
  flexStrWidth,
  isDownloadInteger,
  isDownloadNumber,
  isNumber,
  timestampToTime,
  getCurRegionInfo,
  checkNumber,
  commonSortBy,
  isEmpty,
  isEleEmpty,
  getColumnAlphabet,
  showDieThousand,
  allIntervalTimeStamps,
  getIntervalEndTime,
  calculateDate,
  isMoreThanCurrentDate,
  getArrayCurrencyFormat,
  getCurrencyFormatNew,
  getMultiplier,
  getDataMin,
  getDataMax,
  getDataAverage,
  getCustomShowYData,
  getLocalTimezone,
  timezoneTarget,
  getEcoTimezoneOffset,
  getCustomYearTime,
  getFileDateName,
  getEchartsXData,
  getBackgroundShadowDate,
  addKeyForLocationOptions,
  getYOYAllData
}
